import { render, staticRenderFns } from "./registerUserPayment.vue?vue&type=template&id=4530d46b&scoped=true&"
import script from "./registerUserPayment.vue?vue&type=script&lang=js&"
export * from "./registerUserPayment.vue?vue&type=script&lang=js&"
import style0 from "./registerUserPayment.vue?vue&type=style&index=0&id=4530d46b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4530d46b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4530d46b')) {
      api.createRecord('4530d46b', component.options)
    } else {
      api.reload('4530d46b', component.options)
    }
    module.hot.accept("./registerUserPayment.vue?vue&type=template&id=4530d46b&scoped=true&", function () {
      api.rerender('4530d46b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/registerUserPayment.vue"
export default component.exports